import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import StockExChangeService, { OfferMontsType } from '~/api/services/stockExchange'
import CustomInput from '~/components/CustomInput'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { formatNumber, handleErrors } from '~/utils/helpers'
import { CurrentPriceStyled } from './style'
import { useParams } from 'react-router-dom'
import notify from '~/components/Notify'

interface Props {
  priceData: Nullable<OfferMontsType>
  handleClose: (refetch?: boolean) => void
}

const SetPriceDialog:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { priceData, handleClose } = props
  const { id } = useParams()

  const [newPrice, setNewPrice] = useState('')
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if(props.priceData) {
      setNewPrice('')
    }
  }, [props.priceData])

  function renderPrice() {
    return <div style={{ display: 'flex', alignItems: 'center', gap: 80 }}>
      <CurrentPriceStyled>
        <div className='label'>{t('Current BLE price')}</div>
        <div className='value'>{`${formatNumber(priceData?.price, 2)} €`}</div>
      </CurrentPriceStyled>
      <CustomInput
        label={t('New BLE price')}
        suffix=' €'
        value={newPrice}
        placeholder={t('New BLE price')}
        decimalScale={2}
        withLabels
        allowDecimals
        min={parseFloat(priceData?.price.replace(',', '.')) + 0.01}
        onChange={(value) => setNewPrice(value)}
      />
    </div>
  }

  async function handleSubmitPrice() {
    setIsBusy(true)
    try {
      await StockExChangeService.updateBLEPrice(id, {
        date: priceData?.date,
        currentPrice: priceData?.price,
        price: newPrice.replace(',', '.')
      })
      notify(t('Successfully adjusted BLE price'), 'success')
      handleClose(true)
    } catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function transformValues(value: string) {
    if(isNaN(parseFloat(value))) {
      return 0
    }
    return parseFloat(value.replace(',', '.'))
  }

  return <Dialog
    isDialogOpen={Boolean(priceData)}
    textHeader={t('Adjustment BLE price')}
    handleClose={() => handleClose()}
    textClose={t('Cancel')}
    isLoading={isBusy}
    disableSubmit={transformValues(newPrice) <= transformValues(priceData?.price)}
    textSubmit={t('Adjust BLE price')}
    textContent={<div>
      {renderPrice()}
    </div>}
    type='abort'
    handleSubmit={handleSubmitPrice}
  />
}
export default SetPriceDialog